var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkdin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56812 11.3612C8.56812 9.75349 9.87141 8.4502 11.4791 8.4502H46.6684C48.2761 8.4502 49.5794 9.75349 49.5794 11.3612V46.5504C49.5794 48.1581 48.2761 49.4614 46.6684 49.4614H11.4791C9.87141 49.4614 8.56812 48.1581 8.56812 46.5504V11.3612Z",
    fill: "#0A66C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7734 21.1862C19.7383 21.1862 21.3311 19.5934 21.3311 17.6285C21.3311 15.6636 19.7383 14.0708 17.7734 14.0708C15.8085 14.0708 14.2157 15.6636 14.2157 17.6285C14.2157 19.5934 15.8085 21.1862 17.7734 21.1862Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5894 23.8155H30.4857V26.5166C30.4857 26.5166 32.0857 23.3165 36.4392 23.3165C40.3227 23.3165 43.5398 25.2296 43.5398 31.0609V43.3574H37.4295V32.5509C37.4295 29.111 35.593 28.7327 34.1936 28.7327C31.2893 28.7327 30.7921 31.2378 30.7921 32.9996V43.3574H24.5894V23.8155Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6721 23.8155H20.8748V43.3575H14.6721V23.8155Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.b8d089a87c005655a6f165c4530751b1.svg";
export { ForwardRef as ReactComponent };